import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './audio.css'

export class Audio extends Component {

    state = {
        location: this.props.location,
    }

    static propTypes = {
        location: PropTypes.object.isRequired,
        format: PropTypes.string.isRequired,
        sourceLoading: PropTypes.func.isRequired,
        sourceLoaded: PropTypes.func.isRequired,
        unableToLoadMedia: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
    }

    componentDidMount() {
        this.loadAudio()
    }

    componentWillUnmount() {
        this.audio.removeEventListener("loadeddata", this.audioIsLoaded)
        this.audio.removeEventListener("error", this.props.unableToLoadMedia)
        this.audio = null
    }

    loadAudio() {
        this.props.sourceLoading()

        this.audio.pause()
        this.audio.load()
        this.audio.addEventListener("loadeddata", this.audioIsLoaded)
        this.audio.addEventListener("error", this.props.unableToLoadMedia)
    }
    
    audioIsLoaded = () => {
        this.props.sourceLoaded()
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.location.original !== nextProps.location.original) {
            this.loadAudio()
        }
    }

    render() {
        const { location, format } = this.props

        return (
            <div className="audio-stage">
                <div className={"audio-wrapper"}>
                    <audio
                        controls={this.props.isSourceLoaded && "controls"}
                        src={location.original}
                        type={format}
                        ref={(audio) => {this.audio = audio}}
                    />
                </div>
            </div>
        )
    }
}
